var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_Uint8Array.js
// module id = 1313
// module chunks = 3 9 13